
<section class="bb-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <div class="bb-page-shell">

    <!-- HEADER -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'Financial reports' | transloco }}</span>
        <h1 class="bb-page-title">{{ 'orderprofit' | transloco }}</h1>
        <p class="bb-page-subtitle">{{ 'Order profit description' | transloco }}</p>
      </div>
    </div>

    <div class="bb-form-alert bb-mb-16" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <!-- FILTERS -->
    <div class="bb-filter-card">
      <div class="row g-3">

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label" for="warehouse">{{ 'warehouse' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" id="warehouse" [(ngModel)]="warehouseId" (change)="applyFilters()">
                <option *ngFor="let warehouse of warehouses" [ngValue]="warehouse.id">
                  {{ isAr ? (warehouse.name || warehouse.name_en) : (warehouse.name_en || warehouse.name) }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label" for="year">{{ 'Year' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" id="year" [(ngModel)]="selectedYear" (change)="applyFilters()">
                <option *ngFor="let year of years" [ngValue]="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label" for="month">{{ 'Month' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" id="month" [(ngModel)]="selectedMonth" (change)="applyFilters()">
                <option *ngFor="let month of months" [ngValue]="month.value">
                  {{ month.key | transloco }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SUMMARY -->
    <div class="finance-summary-grid" *ngIf="!loading || profits.length">

      <div class="finance-summary-card finance-summary-card-net">
        <div class="finance-summary-card-head">
          <h6>{{ 'total sales' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalRevenue | number:'1.2-2' }} <small>{{ 'EGP' | transloco }}</small>
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'Total cost' | transloco }}</h6>
        </div>
        <h3 class="finance-value-danger">
          {{ totalCost | number:'1.2-2' }} <small>{{ 'EGP' | transloco }}</small>
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'Net profit' | transloco }}</h6>
        </div>
        <h3 [ngClass]="netProfit < 0 ? 'finance-value-danger' : 'finance-value-success'">
          {{ netProfit | number:'1.2-2' }} <small>{{ 'EGP' | transloco }}</small>
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'Orders' | transloco }}</h6>
        </div>
        <h3 class="bb-text-navy">
          {{ totalRecords | number }}
        </h3>
      </div>

    </div>

    <!-- TABLE -->
    <div class="finance-tables-grid">

      <div class="finance-table-card finance-table-full">

        <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-p-20">
          <h2 class="bb-m-0 bb-text-navy bb-font-bold">
            {{ 'Profit details' | transloco }}
          </h2>

          <span class="bb-badge bb-badge-soft-blue">
            {{ totalRecords }} {{ 'Orders' | transloco }}
          </span>
        </div>

        <app-loading *ngIf="loading"></app-loading>

        <div class="finance-table-scroll" *ngIf="!loading">
          <table class="finance-table" *ngIf="profits.length; else emptyState">
            <thead>
              <tr>
                <th>{{ 'Order' | transloco }}</th>
                <th>{{ 'Users' | transloco }}</th>
                <th>{{ 'Items / Qty' | transloco }}</th>
                <th>{{ 'Date' | transloco }}</th>
                <th>{{ 'Gross sales' | transloco }}</th>
                <th>{{ 'Products cost' | transloco }}</th>
                <th>{{ 'Deductions' | transloco }}</th>
                <th>{{ 'Net profit' | transloco }}</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of profits">

                <td data-label="Order">
                  #{{ row.order_id || row.id || '-' }}
                </td>

                <td data-label="User">
                  {{ row.username || row.user_id || '-' }}
                </td>

                <td data-label="Items / Qty">
                  {{ row.items_count || 0 }} / {{ row.total_quantity || 0 }}
                </td>

                <td data-label="Date">
                  {{ row.created_at ? (row.created_at | date:'mediumDate') : '-' }}
                </td>

                <td data-label="Gross sales">
                  <span class="finance-main-text finance-value-success">
                    {{ rowRevenue(row) | number:'1.2-2' }} {{ 'EGP' | transloco }}
                  </span>
                </td>

                <td data-label="Products cost">
                  <span class="finance-main-text finance-value-danger">
                    {{ rowCost(row) | number:'1.2-2' }} {{ 'EGP' | transloco }}
                  </span>
                </td>

                <td data-label="Deductions">
                  {{ rowDeductions(row) | number:'1.2-2' }} {{ 'EGP' | transloco }}
                </td>

                <td data-label="Net profit">
                  <span class="finance-main-text" [ngClass]="rowProfit(row) < 0 ? 'finance-value-danger' : 'finance-value-success'">
                    {{ rowProfit(row) | number:'1.2-2' }} {{ 'EGP' | transloco }}
                  </span>
                </td>

              </tr>
            </tbody>
          </table>

          <ng-template #emptyState>
            <div class="bb-empty-state">
              <div class="bb-text-center">
                <i class="fa-solid fa-chart-line bb-text-muted"></i>
                <p class="bb-text-muted bb-font-bold bb-mt-12">
                  {{ 'No order profits' | transloco }}
                </p>
              </div>
            </div>
          </ng-template>
        </div>

        <!-- PAGINATION -->
        <div class="bb-paginator bb-flex bb-items-center bb-justify-center bb-gap-12 bb-p-12" *ngIf="lastPage > 1">

          <button
            type="button"
            class="bb-btn bb-btn-secondary bb-btn-sm"
            (click)="changePage(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            {{ 'Previous' | transloco }}
          </button>

          <span class="bb-font-bold bb-text-navy">
            {{ currentPage }} / {{ lastPage }}
          </span>

          <button
            type="button"
            class="bb-btn bb-btn-secondary bb-btn-sm"
            (click)="changePage(currentPage + 1)"
            [disabled]="currentPage === lastPage"
          >
            {{ 'Next' | transloco }}
          </button>

        </div>

      </div>

    </div>

  </div>
</section>